<template>
  <v-container>

    <!-- toolbar container, to prevent parent flexer shrinking children like hlines -->
    <div>
      <v-container fluid pa-0 pb-4 style="position: relative;">
        <!-- PC TOOLBAR -->
        <div v-if="!$vuetify.breakpoint.xs" class="mt-4 pl-4 pr-4 pt-4">

          <v-layout align-center>
            <div class="display-1 mt-4">
              Sales
            </div>
          </v-layout>

          <v-tabs v-model="activeTab" centered>
            <v-tab>In process</v-tab>
            <v-tab>Complete</v-tab>
          </v-tabs>
        </div>

        <!-- MOBILE toolbar -->
        <div v-if="$vuetify.breakpoint.xs" class="toolbar-mobile">
          <v-layout align-center>
            <v-btn icon @click="drawer = !drawer">
              <v-icon>menu</v-icon>
            </v-btn>
            <v-flex class="text-ellipsed text-sans font-weight-bold">
              Sales
            </v-flex>
          </v-layout>
          <v-tabs v-model="activeTab" background-color="foreground" centered fixed-tabs style="max-width: 800px;" class="mx-auto">
            <v-tab>In process</v-tab>
            <v-tab>Complete</v-tab>
          </v-tabs>
        </div>
      </v-container>
    </div>
    <!-- end toolbar container, to prevent parent flexer shrinking children linke hlines -->

    <!-- MAIN CONTENT -->
    <div style="overflow: auto;">
      <v-container fluid class="pa-0">
        <sales-in-process v-if="activeTab === 0"></sales-in-process>
        <sales-complete v-if="activeTab === 1"></sales-complete>
      </v-container>
    </div>

  </v-container>
</template>

<script>
import SalesComplete from './SalesComplete'
import SalesInProcess from './SalesInProcess'

export default {
  name: 'productions',
  components: {
    SalesComplete,
    SalesInProcess
  },
  data () {
    return {
      activeTab: 0
    }
  },
  computed: {
    drawer: {
      get () {
        return this.$store.state.navMain
      },
      set (val) {
        this.$store.commit('openNavMain', val)
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>

